import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useWorkData } from '../hooks/useWorkData';
import { useWorkNavigation } from '../hooks/useNavigation';
import DemoCarousel from './DemoCarousel';

function Work() {
  const { workid } = useParams<{ workid: string }>();
  const navigateToWork = useWorkNavigation();
  const { work, prev, next } = useWorkData(workid);
  
  if (!work) {
    return <Navigate to="/work" replace />;
  }

  const previousButton = prev ? (
    <button 
      aria-label="Previous work" 
      className="directionButton prev-button" 
      onClick={() => navigateToWork(prev.name)} 
    >
      <span className="arrow-left"></span>
    </button>
  ) : (
    <div className="directionButton-placeholder"></div>
  );

  const nextButton = next ? (
    <button 
      aria-label="Next work"
      className="directionButton next-button" 
      onClick={() => navigateToWork(next.name)} 
    >
      <span className="arrow-right"></span>
    </button>
  ) : (
    <div className="directionButton-placeholder"></div>
  );

  return (
    <div style={{ margin: "auto" }}>
      <div className="navigation-arrows">
        {previousButton}
        {nextButton}
      </div>
      <DemoCarousel selectedId={workid!} onSelectionChange={navigateToWork} />
    </div>
  );
}

export default Work;